import React from 'react';
import { AuthContextProps } from './types';

export const createContext = <
  T extends string,
  P extends string,
  R extends string
>() =>
  React.createContext<AuthContextProps<T, P, R>>({
    checkRole: () => false,
    getUserRoles: () => [],
    getValidRoles: () => [],
    switchRoles: () => {},
    getUserInformation: () => ({}),
    authorizeData: () => {},
    logout: () => {},
  });
